import React, { useState, useEffect } from 'react';
import {
  Modal,
  Fade,
  Container,
  Paper,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import { RxCross2 } from "react-icons/rx";
import { motion, AnimatePresence } from 'framer-motion';
import ForgotPasswordPage from './ForgotPasswordPage';
import Logo from '../Assets/images/ConnectHealthPro.png';

export default function PasswordResetModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Fade in={open}>
        <Container maxWidth="sm">
          <Paper 
            sx={{ 
              position: 'relative',
              p: 3,
              maxHeight: '90vh',
              overflow: 'auto'
            }}
            component={motion.div}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                zIndex: 1
              }}
            >
              <RxCross2 />
            </IconButton>

            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              mb: 3
            }}>
              <img
                src={Logo}
                alt="ConnectHealthPro"
                style={{ height: 60, marginBottom: 16 }}
              />
              <Typography variant="h5" sx={{ 
                color: 'primary.main',
                fontWeight: 600,
                textAlign: 'center'
              }}>
                Reset Your Password
              </Typography>
              <Typography variant="body2" sx={{ 
                color: 'text.secondary',
                textAlign: 'center',
                mt: 1
              }}>
                Please follow the steps to reset your password securely
              </Typography>
            </Box>
            
            <ForgotPasswordPage isModal={true} onClose={onClose} />
          </Paper>
        </Container>
      </Fade>
    </Modal>
  );
}
